import bootstrap from "bootstrap/dist/js/bootstrap.min.js";
import { nextTick } from "vue";

const getSafeTitle = (value) => {
  if (value === null || value === undefined || typeof value === 'boolean') {
      return '';
  }
  if (typeof value !== 'string' && typeof value !== 'function') {
      return String(value);
  }
  return value;
};
export const tooltip = {
  
  mounted(el, binding) {
    nextTick(() => {
      const tooltipText = getSafeTitle(binding.value);
      const placement = binding.arg || 'top'; // Argumento: v-tooltip:right -> placement='right'
      const options = {
        title: tooltipText,
        placement: placement,
        html: true,
        trigger: 'hover'
        // Opcional: Si quieres un contenedor específico para evitar problemas de clipping
        // container: 'body', 
        // Opcional: Otras opciones como customClass, delay, etc.
      };
      el.__tooltipInstance = new bootstrap.Tooltip(el, options);
    });
  },

  updated(el, binding) {
    if (el.__tooltipInstance && binding.value !== binding.oldValue) {
      const newTitle = getSafeTitle(binding.value);
      el.__tooltipInstance._config.title = newTitle;
    }
  },

 unmounted(el) {
    try {
      if (el.__tooltipInstance && typeof el.__tooltipInstance.dispose === "function") {
        el.__tooltipInstance.dispose();
      }
    } catch (e) {
      // ignore
    } finally {
      el.__tooltipInstance = null;
    }
  },
};